import { render, staticRenderFns } from "./list.vue?vue&type=template&id=967c0a1a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=967c0a1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c0a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967c0a1a')) {
      api.createRecord('967c0a1a', component.options)
    } else {
      api.reload('967c0a1a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=967c0a1a&scoped=true", function () {
      api.rerender('967c0a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/task/list.vue"
export default component.exports